class Sentiment {
  public static Positive = "positive";
  public static Negative = "negative";
  public static Neutral = "neutral";
  public static Mixed = "mixed";
}

export default Sentiment;
